/**
 * WebGL context loss: pause everything, show a 1994 "SIGNAL LOST" card,
 * resume when the browser restores the context (three rebuilds GL state).
 */
import { LEX } from '../strings/lexicon';
import type { LoopHandle } from './loop';

export function watchContextLoss(
  canvas: HTMLCanvasElement,
  loop: LoopHandle,
  parent: HTMLElement,
): void {
  let card: HTMLDivElement | null = null;

  canvas.addEventListener('webglcontextlost', (e) => {
    e.preventDefault(); // allow restoration
    loop.pause();
    card = document.createElement('div');
    card.style.cssText = [
      'position:fixed',
      'inset:0',
      'display:grid',
      'place-items:center',
      'background:#050805',
      'z-index:60',
      'color:#33FF66',
      'font:bold 16px/2 monospace',
      'letter-spacing:3px',
      'text-align:center',
    ].join(';');
    card.textContent = `${LEX.signalLost()}\n${LEX.signalWaiting()}`;
    parent.appendChild(card);
  });

  canvas.addEventListener('webglcontextrestored', () => {
    card?.remove();
    card = null;
    loop.resume();
  });
}
